import { styled } from '@material-ui/core';
import { ReactNode } from 'react';

interface Props {
  className?: string;
  children?: ReactNode;
}

const ContentSection = ({ children, className }: Props) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

export default ContentSection;

const Wrapper = styled('div')({
  padding: '0px 24px 24px'
});
